/**
 * @generated SignedSource<<d2fab5b9f428b4006d0b7dbc7205e682>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CourseCardSummary_course$data = {
  readonly facility: {
    readonly id: string;
    readonly slug: string;
  };
  readonly id: string;
  readonly " $fragmentType": "CourseCardSummary_course";
};
export type CourseCardSummary_course$key = {
  readonly " $data"?: CourseCardSummary_course$data;
  readonly " $fragmentSpreads": FragmentRefs<"CourseCardSummary_course">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CourseCardSummary_course",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Facility",
      "kind": "LinkedField",
      "name": "facility",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Course",
  "abstractKey": null
};
})();

(node as any).hash = "a9700a38cd656f382ee36e616dd7e51c";

export default node;
